import { useState } from "react";
import { Facebook, Instagram, Youtube, Linkedin, Twitter } from "lucide-react";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { BRAND, NAV_LINKS } from "@/data/content";
import { LEGAL } from "@/data/legal";

const SOCIALS = [
  { key: "facebook", label: "Facebook", icon: Facebook, url: "https://www.facebook.com/share/1bgQCNyXRy/" },
  { key: "instagram", label: "Instagram", icon: Instagram, url: "https://www.instagram.com/sahiclaim?igsh=Yng1aGM3OHVidWZy" },
  { key: "youtube", label: "YouTube", icon: Youtube, url: "#" },
  { key: "linkedin", label: "LinkedIn", icon: Linkedin, url: "#" },
  { key: "x", label: "X", icon: Twitter, url: "#" },
];

export const Footer = () => {
  const [active, setActive] = useState(null);
  const doc = LEGAL.find((l) => l.key === active);

  return (
    <footer className="bg-ink text-zinc-400 border-t border-zinc-900 py-16" data-testid="footer">
      <div className="max-w-7xl mx-auto px-6 sm:px-8 lg:px-12">
        <div className="flex flex-col md:flex-row md:items-center justify-between gap-8 pb-10 border-b border-zinc-900">
          <a href="#top" className="flex items-center gap-2.5">
            <img src="/logo-white.png" alt="Sahi Claim logo" className="h-14 w-14 object-contain" />
            <span className="text-2xl font-bold tracking-tight text-white">Sahi <span className="text-forest-light">Claim</span><sup className="text-[0.5em] align-super text-white font-semibold ml-0.5">™</sup></span>
          </a>
          <nav className="flex flex-wrap gap-x-8 gap-y-3">
            {NAV_LINKS.map((l) => (
              <a key={l.href} href={l.href} className="text-sm hover:text-white transition-colors">{l.label}</a>
            ))}
          </nav>
        </div>

        <div className="py-8 border-b border-zinc-900 flex flex-wrap gap-x-8 gap-y-3">
          {LEGAL.map((l) => (
            <button key={l.key} onClick={() => setActive(l.key)} data-testid={`legal-${l.key}`}
              className="text-sm text-zinc-400 hover:text-forest-light transition-colors">
              {l.title}
            </button>
          ))}
        </div>

        <div className="py-8 border-b border-zinc-900 flex flex-col sm:flex-row sm:items-center gap-4">
          <span className="text-sm font-semibold text-white tracking-tight mr-2">Follow Us</span>
          <div className="flex items-center gap-4">
            {SOCIALS.map((s) => (
              <a key={s.key} href={s.url} target="_blank" rel="noreferrer" aria-label={s.label} data-testid={`social-${s.key}`}
                className="h-10 w-10 rounded-full border border-zinc-800 flex items-center justify-center text-zinc-400 hover:text-white hover:bg-forest hover:border-forest transition-colors duration-300">
                <s.icon size={18} />
              </a>
            ))}
          </div>
        </div>

        <div className="pt-8 flex flex-col sm:flex-row justify-between gap-4 text-sm">
          <p className="max-w-md">{BRAND.name} — Independent insurance claim advisory & resolution consultancy. Not affiliated with any insurer.</p>
          <p>© {new Date().getFullYear()} {BRAND.name}. All rights reserved.</p>
        </div>
      </div>

      <Dialog open={!!active} onOpenChange={(o) => !o && setActive(null)}>
        <DialogContent className="max-w-2xl max-h-[80vh] overflow-y-auto" data-testid="legal-dialog">
          <DialogHeader>
            <DialogTitle className="text-2xl font-bold tracking-tight text-ink">{doc?.title}</DialogTitle>
          </DialogHeader>
          <div className="space-y-4 text-sm text-zinc-600 leading-relaxed">
            {doc?.body.map((p, i) => <p key={i}>{p}</p>)}
          </div>
        </DialogContent>
      </Dialog>
    </footer>
  );
};

export default Footer;
